import { combineReducers } from "redux";
import admin from "./Admin";
import allHistory from "./AllHistories";
import allergies from "./Allergies";
import recording from "./AmbientAI/Recording";
import createNewPassword from "./Auth/CreateNewPassword";
import forgotPassword from "./Auth/ForgotPassword";
import auth from "./Auth/Login";
import encounter from "./Encounter";
import endVisit from "./EndVisit";
import familyHistory from "./FamilyHistory";
import favorites from "./Favorites";
import kcfSelection from "./KcfSelection";
import onboardingCue from "./OnboardingCue";
import globalStates from "./GlobalState";
import icdCode from "./IcdCodes";
import images from "./Images";
import labLocations from "./Labs/LabLocations";
import labProviders from "./Labs/LabProviders";
import labs from "./Labs/Orders";
import locations from "./Locations";
import medicines from "./Medications/Medicines";
import orderMedications from "./Medications/OrderMedications";
import medications from "./Medications/PatientMedications";
import MyTeams from "./MyTeam";
import specificPatient from "./Patients/GetSpecificPatient";
import patients from "./Patients/ScheduledAppointment";
import resultsLabs from "./Patients/ViewLabResults";
import pharmacy from "./Pharmacy";
import changePassword from "./PrivacySecurity";
import procedures from "./Procedures";
import referrals from "./Referrals";
import smartRecommendations from "./SmartRecommendations";
import vitals from "./Vitals";
import options from "./common/Options";
import globalError from "./common/globalError";

const appReducer = combineReducers({
  auth,
  labs,
  allHistory,
  admin,
  vitals,
  recording,
  globalStates,
  icdCode,
  options,
  MyTeams,
  patients,
  locations,
  encounter,
  resultsLabs,
  orderMedications,
  medications,
  globalError,
  pharmacy,
  changePassword,
  specificPatient,
  createNewPassword,
  familyHistory,
  medicines,
  allergies,
  forgotPassword,
  labProviders,
  labLocations,
  smartRecommendations,
  favorites,
  referrals,
  images,
  procedures,
  endVisit,
  kcfSelection,
  onboardingCue,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === "auth/logoutSuccess" || action.type === "auth/postOidcLogoutSuccess") {
    const { locations, getFlags } = state; // Extract the `locations` and `getFlags` slices

    // Clear all localStorage except user-specific location preferences
    // User-specific keys start with 'user_location_', 'user_provider_', 'user_multiple_providers_'
    const keysToPreserve: string[] = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && (key.startsWith("user_location_") || key.startsWith("user_provider_") || key.startsWith("user_multiple_providers_"))) {
        keysToPreserve.push(key);
      }
    }

    // Save values to preserve
    const preservedValues: Record<string, string> = {};
    keysToPreserve.forEach((key) => {
      const value = localStorage.getItem(key);
      if (value) {
        preservedValues[key] = value;
      }
    });

    // Clear localStorage
    localStorage.clear();

    // Restore preserved values
    Object.entries(preservedValues).forEach(([key, value]) => {
      localStorage.setItem(key, value);
    });

    state = appReducer(undefined, action);

    // Restore the location and feature flag slices, but clear user-specific selections
    // User-specific location preferences are stored separately in localStorage
    // and will be restored on next login
    return {
      ...state,
      locations: {
        ...locations,
        activeLocation: {},
        activeProvider: {},
        multipleActiveProviders: [],
      },
      getFlags,
    };
  }

  return appReducer(state, action);
};

export default rootReducer;
